import { MenuItem } from '../models/menu.model';

export const MENU_ITEMS: MenuItem[] = [
  { label: 'menu.dashboard', icon: 'pi pi-home', path: '/dashboard' },
  { label: 'menu.users', icon: 'pi pi-users', path: '/usuarios' },
  { label: 'menu.clients', icon: 'pi pi-link', path: '/clientes' },
  { label: 'menu.roles', icon: 'pi pi-shield', path: '/roles' },
  { label: 'menu.permissions', icon: 'pi pi-key', path: '/permisos' },
];
